// extracted by css-extract-rspack-plugin
export default {"header":"_990f48ae","isSwiperCarousel":"_7813f931","alignTitleLeft":"_571fbaa7","centerTitle":"_960257da","title":"_3250f891","viewMore":"_36f4d129","carousel":"_a6aa8f61"};